module.exports = __webpack_public_path__ + "public/img/total9.b0a331ba.png";